<div>
    <p-steps [model]="items" [ngStyle]="{'display':'inline-flex'}"></p-steps>
    <span style="color: var(--gray-200);">{{"Key.Steps" | translate}}</span>
</div>
